/* Display-only alpha masks. The original artwork is kept intact on disk.
   One cached canvas pass per asset removes the baked checkerboard, including
   the handle/facemask openings. No work runs in the animation loop. */
(() => {
  const cache = new Map();
  const openings = {
    camcorder: [[.47, .25]],
    'garage-keepsakes': [[.674,.245],[.688,.293],[.745,.288],[.749,.334],[.686,.328]]
  };
  function source(name) {
    if (cache.has(name)) return cache.get(name);
    const promise = new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin='anonymous';
      const timer = setTimeout(() => reject(new Error('Cutout did not load')), 5000);
      image.onerror = () => { clearTimeout(timer); reject(new Error('Cutout unavailable')); };
      image.onload = () => {
        clearTimeout(timer);
        try {
          const canvas = document.createElement('canvas');
          const w = canvas.width = image.naturalWidth, h = canvas.height = image.naturalHeight;
          const context = canvas.getContext('2d', { willReadFrequently:true });
          context.drawImage(image,0,0);
          const pixels = context.getImageData(0,0,w,h), data = pixels.data;
          const removed = new Uint8Array(w*h), queue = new Int32Array(w*h);
          let head=0,tail=0;
          function add(i) {
            if(i<0||i>=w*h||removed[i])return;
            const at=i*4,r=data[at],g=data[at+1],b=data[at+2];
            if(Math.min(r,g,b)<158||Math.max(r,g,b)-Math.min(r,g,b)>28)return;
            removed[i]=1;queue[tail++]=i;
          }
          for(let x=0;x<w;x++){add(x);add((h-1)*w+x)}
          for(let y=0;y<h;y++){add(y*w);add(y*w+w-1)}
          for(const [x,y] of openings[name]||[])add(Math.floor(y*h)*w+Math.floor(x*w));
          while(head<tail){const i=queue[head++],x=i%w;add(i-w);add(i+w);if(x)add(i-1);if(x<w-1)add(i+1)}
          for(let i=0;i<w*h;i++)if(removed[i])data[i*4+3]=0;
          // Despill only the one-pixel silhouette edge; keep labels and controls intact.
          for(let y=1;y<h-1;y++)for(let x=1;x<w-1;x++){
            const i=y*w+x;if(removed[i])continue;
            if(!removed[i-1]&&!removed[i+1]&&!removed[i-w]&&!removed[i+w])continue;
            const at=i*4,r=data[at],g=data[at+1],b=data[at+2];
            if(Math.min(r,g,b)>125&&Math.max(r,g,b)-Math.min(r,g,b)<38)data[at+3]=80;
          }
          context.putImageData(pixels,0,0);
          resolve(canvas.toDataURL('image/png'));
        } catch(error) { reject(error); }
      };
      image.src=new URL(JSON.parse(document.getElementById('oasa-config').dataset.config).assets[name+'.webp'],location.href).href;
    });
    cache.set(name,promise);
    return promise;
  }
  function apply(element,name) {
    source(name).then(url=>{element.src=url;element.dataset.cutoutReady='true';})
      .catch(()=>{element.hidden=true;});
  }
  window.OASA_CUTOUTS={source,apply};
})();
